const rankingItems = [
  {
    rank: 1,
    title: '庆余年第二季',
    tag: '权谋·古装',
    heat: '热度 3580万',
    desc: '张若昀、李沁主演，范闲重返京都搅动风云，剧情持续高能，话题讨论量全网第一。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20imperial%20court%20drama%20scene%20with%20elaborate%20robes%20and%20grand%20palace%20interior%2C%20dramatic%20lighting%2C%20warm%20golden%20tones%2C%20cinematic%20composition&width=400&height=280&seq=bbtv-rank-01&orientation=landscape',
  },
  {
    rank: 2,
    title: '流浪地球2',
    tag: '科幻·灾难',
    heat: '热度 2150万',
    desc: '国产科幻巅峰，吴京刘德华联手拯救地球，特效炸裂、剧情催泪，不可错过的视觉盛宴。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20scene%20with%20massive%20space%20station%20and%20Earth%20in%20background%2C%20cool%20blue%20and%20warm%20orange%20lighting%2C%20epic%20sci-fi%20cinematic&width=400&height=280&seq=bbtv-rank-02&orientation=landscape',
  },
  {
    rank: 3,
    title: '长风渡',
    tag: '古装·爱情',
    heat: '热度 1280万',
    desc: '白敬亭宋轶演绎乱世商海传奇，从布衣到首富的逆袭故事，全集上线一次看过瘾。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20romantic%20drama%20scene%20with%20lakeside%20pavilion%2C%20soft%20sunset%20lighting%2C%20flowing%20hanfu%2C%20poetic%20atmosphere%2C%20cinematic&width=400&height=280&seq=bbtv-rank-03&orientation=landscape',
  },
  {
    rank: 4,
    title: '大奉打更人',
    tag: '探案·喜剧',
    heat: '热度 980万',
    desc: '王鹤棣古装探案喜剧，轻松幽默与悬疑推理兼得，下饭神剧代表，全集畅快追。',
    img: 'https://readdy.ai/api/search-image?query=Ming%20dynasty%20detective%20scene%20in%20ancient%20Chinese%20city%2C%20warm%20lantern%20light%2C%20mysterious%20atmosphere%2C%20period%20costume%20drama%2C%20cinematic&width=400&height=280&seq=bbtv-rank-04&orientation=landscape',
  },
  {
    rank: 5,
    title: '繁花',
    tag: '年代·商战',
    heat: '热度 860万',
    desc: '胡歌主演王家卫首部电视剧，90年代上海商海浮沉，电影级质感，每一帧都是艺术品。',
    img: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20with%20neon%20lights%20and%20vintage%20cars%2C%20cinematic%20noir%20lighting%2C%20nostalgic%20atmosphere%2C%20film%20quality&width=400&height=280&seq=bbtv-rank-05&orientation=landscape',
  },
  {
    rank: 6,
    title: '狂飙',
    tag: '刑侦·扫黑',
    heat: '热度 740万',
    desc: '张译张颂文演技炸裂，扫黑除恶题材力作，剧情张弛有度，国产刑侦剧新标杆。',
    img: 'https://readdy.ai/api/search-image?query=Tense%20police%20interrogation%20room%20scene%2C%20dramatic%20overhead%20lighting%2C%20moody%20shadows%2C%20crime%20drama%20aesthetic%2C%20cinematic&width=400&height=280&seq=bbtv-rank-06&orientation=landscape',
  },
];

const rankColors = [
  'bg-primary-500 text-background-50',
  'bg-accent-500 text-background-50',
  'bg-secondary-500 text-background-50',
  'bg-background-200 text-foreground-600',
  'bg-background-200 text-foreground-600',
  'bg-background-200 text-foreground-600',
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            热播榜单
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-foreground-900">
            全网热播 TOP 6
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            基于播放量与讨论热度的实时榜单，看看大家都在追什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {rankingItems.map((item, idx) => (
            <article
              key={idx}
              className="group flex gap-4 bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-extrabold text-sm flex-shrink-0 ${rankColors[idx]}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1.5">
                  <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="whitespace-nowrap px-1.5 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-primary-500 font-heading font-bold">
                    {item.heat}
                  </span>
                  <div className="flex-1">
                    <div className="h-1.5 rounded-full bg-background-100 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-primary-400"
                        style={{ width: `${100 - idx * 14}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-20 h-14 md:w-24 md:h-16 rounded-lg overflow-hidden flex-shrink-0 bg-background-100">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}